<template>
  <div>
    <div v-for="(document, index) in documents"
         id="documentos"
         :key="`preparar_processo_document_${index}`"
         class="AdicionarImagem--border mb-3">
      <div class="AdicionarImagem--header p-1 icons--white">
        <div class="row no-gutters">
          <div class="col-3">
            {{ document.label }}
          </div>

          <div v-if="document.label != 'Memorial' && document.label != 'Edital'"
               class="col">
            <b-form-checkbox
              v-show="document.url_s3 == null"
              v-model="document.anexado"
              switch
              :value="true"
              @keyup.native.enter="document.anexado= !document.anexado">
              Anexado em outro documento
            </b-form-checkbox>
          </div>
        </div>
      </div>

      <div v-show="!document.anexado">
        <div class="row p-2 m-0">
          <div class="col">
            <div class="row">
              <div class="col-6">
                <div>
                  <div class="DropArea AdicionarImagem--border">
                    <div v-show="!document.url_s3">
                      <span v-show="showNameFiles && !!inputFiles(index)">
                        <b>Arquivo selecionado: </b>{{ showNameFiles && inputFiles(index) }}<br>
                        <small>Para trocar, arraste o arquivo PDF  aqui ou <label for="preparar-processo-imagem"><u>procure manualmente</u></label> para upload </small>
                      </span>

                      <span v-show="showNameFiles && !inputFiles(index)">
                        Arraste o arquivo PDF aqui ou <label for="preparar-processo-imagem"><u>procure manualmente</u></label> para upload
                      </span>
                    </div>

                    <div v-show="document.url_s3">
                      <b class="text-primary">Documento já anexado</b>
                    </div>
                  </div>

                  <input v-show="!document.url_s3"
                         id="preparar-processo-imagem"
                         v-validate="{required: (index == 0 && !document.anexado && !document.url_s3) ? true: false, mimes: ['application/pdf']}"
                         type="file"
                         :name="`name_${ index }`"
                         :class="['form-control-sm form-control-file fileObrigatorio', `documento_${document.label}`]"
                         accept="application/pdf"
                         @dragover="($event) => dragArea($event, index)"
                         @dragleave="($event) => dragAreaOut($event, index)"
                         @drop="drop(index)"
                         @change="showName">

                  <label v-if="1 != 1"
                         for="preparar-processo-imagem"
                         class="label">Adicionar um documento</label>

                  <div v-show="document.anexado || document.url_s3"
                       v-if="1 != 1"
                       class="mt-1 mb-1">
                    <span class="DocumentosObrigatorios--fileDisabled">
                      Documento já anexado
                    </span>
                  </div>

                  <div v-if="errors.has(`name_${ index }`) && index == 0 && document.label === 'Memorial'"
                       class="text-center">
                    <small class="text-danger">Upload do memorial obrigatório, certifique-se de estar escolhendo um documento <strong>PDF</strong></small>
                  </div>

                  <div v-if="errors.has(`name_${ index }`) && index != 0"
                       class="text-center">
                    <small class="text-danger">Certifique-se de estar escolhendo um documento <strong>PDF</strong></small>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label for="imagem_tipo_documento"
                         class="label">
                    Tipo de Documento
                  </label>

                  <div><small>{{ document.tipo_documento }}</small></div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label for="imagem_tag"
                         class="label">Tag</label>

                  <div><small>{{ document.tag }}</small></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col mb-5">
      <div class="row">
        <div class="col text-right pr-0">
          <button class="btn btn-secondary btn-sm ml-2"
                  @click="add()">
            Adicionar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* services */
  import UploadTemporarioService from "@/services/Arquivos/UploadTemporarioService"

  /* libraries */
  import Swal from 'sweetalert2'

  /* constants */
  import { EDITAL_OUTRA_SERVENTIA } from "@/constants/casamento/tipos"

  export default {
    name: "DocumentosObrigatorios",
    props: {
      propDocuments: {
        type: Array,
        default: () => []
      },
      propTipoDocumento: {
        type: String,
        default: () => null
      }
    },
    data () {
      return {
        EDITAL_OUTRA_SERVENTIA,
        showNameFiles: true,
        documents: [
          {
            anexado: false,
            label: 'Memorial',
            url_s3: null,
            tipo_documento: 'Comum',
            tag: 'Memorial',
            correspondente: 'Ambos',
            obrigatorio: true
          },
          {
            anexado: false,
            label: 'Edital',
            url_s3: null,
            tipo_documento: 'Comum',
            tag: 'Edital de Proclamas - Emitido pelo outro cartório',
            correspondente: 'Ambos',
            obrigatorio: true
          },
          {
            anexado: false,
            label: 'Certidão de Cônjuge 1',
            url_s3: null,
            tipo_documento: 'Certidões',
            tag: 'Certidão1',
            correspondente: 'Cônjuge 1',
            obrigatorio: false
          },
          {
            anexado: false,
            label: 'Documento de Identidade de Cônjuge 1',
            url_s3: null,
            tipo_documento: 'Certidões',
            tag: 'Doc Identidade1',
            correspondente: 'Cônjuge 1',
            obrigatorio: false
          },
          {
            anexado: false,
            label: 'Certidão de Cônjuge 2',
            url_s3: null,
            tipo_documento: 'Certidões',
            tag: 'Certidão2',
            correspondente: 'Cônjuge 2',
            obrigatorio: false
          },
          {
            anexado: false,
            label: 'Documento de Identidade de Cônjuge 2',
            url_s3: null,
            tipo_documento: 'Certidões',
            tag: 'Doc Identidade2',
            correspondente: 'Cônjuge 2',
            obrigatorio: false
          }
        ]
      }
    },
    watch: {
      propDocuments () {
        this.init()
      },
      propTipoDocumento: function (newVal) {
        if (!newVal) return

        // Retiramos o documento Memorial caso for Afixação de edital de outra serventia
        if (newVal === this.EDITAL_OUTRA_SERVENTIA) {
          const docMemorial = this.documents.find(documento => documento.label === 'Memorial')

          if (docMemorial) {
            const indexMemorial = this.documents.indexOf(docMemorial)

            this.documents.splice(indexMemorial, 1)
          }
        } else {
          // Validamos se o item 0 não é Memorial para não duplicar
          if (this.documents[0].label !== 'Memorial') {
            this.documents.splice(0, 0, {
              anexado: false,
              label: 'Memorial',
              url_s3: null,
              tipo_documento: 'Comum',
              tag: 'Memorial',
              correspondente: 'Ambos',
              obrigatorio: true
            })
          }


          const docEdital = this.documents.find(documento => documento.label === 'Edital')

          if (docEdital) {
            const indexEdital = this.documents.indexOf(docEdital)

            this.documents.splice(indexEdital, 1)
          }
        }
      }
    },
    beforeMount () {
      this.init()
    },
    mounted () {
      this.init()

      setTimeout(() => {
        const firstDropArea = document.querySelector('.documento_Memorial')
        if (firstDropArea) {
          firstDropArea.focus()
        }
      }, 100)
    },
    methods: {
      init () {
        if (!this.propTipoDocumento) return

        if (this.propDocuments.length > 0) {
          this.checkDocuments()
        }

        // Retiramos o documento Memorial caso for Afixação de edital de outra serventia
        if (this.propTipoDocumento === this.EDITAL_OUTRA_SERVENTIA) {
          const docMemorial = this.documents.find(documento => documento.label === 'Memorial')

          if (docMemorial) {
            const indexMemorial = this.documents.indexOf(docMemorial)

            this.documents.splice(indexMemorial, 1)
          }
        } else {
          // removemos o edital dos documentos obrigarios caso não seja tipo "Afixação de edital de outra serventia"
          const docEdital = this.documents.find(documento => documento.label === 'Edital')

          if (docEdital) {
            const indexEdital = this.documents.indexOf(docEdital)


            this.documents.splice(indexEdital, 1)
          }
        }
      },

      // Deixamos o array de documents somente com os que não foram importados
      checkDocuments () {
        this.propDocuments.forEach(document => {
          const getDocumentoImportado = this.documents.find(doc => doc.tag === document.tag)

          if (getDocumentoImportado && document.url_s3) {
            const indexDocumentoImportado = this.documents.indexOf(getDocumentoImportado)

            this.documents[indexDocumentoImportado] = document
          }
        })
      },

      async add () {
        this.$validator.validate().then(async (res) => {
          if (res) {
            const naoAnexados = this.documents.filter(documento => {
              return !documento.anexado
            })

            if (!naoAnexados.length) {
              objSwal.error.title = 'Erro ao adicionar!'
              objSwal.error.text = 'Todos os documentos estão anexados em outro documento.'
              objSwal.error.html = ''

              return Swal.fire(objSwal.error)
            }

            try {
              loader({ text: "Obtendo dados...", active: true })

              const documentsFiles = document.querySelectorAll('.fileObrigatorio')

              for (let i = 0; i < documentsFiles.length; i++) {
                if (documentsFiles[i].files.length > 0) {
                  // passando index e arquivo para o método
                  await this.adicionarImagem(i, documentsFiles[i].files[0])
                }
              }

              const documents = this.documents.filter(document => document.url_s3 || document.anexado)

              this.$emit('onAdd', documents)
            } catch (e) {
              objSwal.error.title = "Erro ao fazer upload!"
              objSwal.error.text = ''
              Swal.fire(objSwal.error)

              throw "Não foi possível realizar o upload do arquivo temporário em AdicionarImagem" + e
            } finally {
              loader({ text: "Obtendo dados...", active: false })
            }
          }
        })

      },

      async adicionarImagem (index, files) {
        try {
          let form = new FormData()

          if (this.$route.name === 'habilitar_casamento') {
            form.append('tipo', 'rascunho')
            form.append('rascunho_id', this.$route.params.id)
          } else {
            form.append('tipo', 'registro')
            form.append('registro_id', this.$route.params.id)
          }

          form.append('file', files)
          const upload = await UploadTemporarioService.uploadTemporario(form)

          if (upload.success == true) {
            this.documents[index].url_s3 = upload.url_s3
          }
        } catch (e) {
          objSwal.error.title = "Erro ao fazer upload!"
          objSwal.error.text = e
          Swal.fire(objSwal.error)
          throw "Não foi possível realizar o upload do arquivo temporário em AdicionarImagem"
        }
      },

      dragArea ($event, index) {
        const element = document.querySelectorAll('.DropArea')[index]
        element.classList.add('DropAreaDrag')
        $event.preventDefault()
      },

      dragAreaOut ($event, index) {
        const element = document.querySelectorAll('.DropArea')[index]
        element.classList.remove('DropAreaDrag')
        $event.preventDefault()
      },

      drop (index) {
        const element = document.querySelectorAll('.DropArea')[index]
        element.classList.remove('DropAreaDrag')
      },

      inputFiles (index) {
        const element = document.querySelectorAll('.fileObrigatorio')[index]
        return element && element.files[0] && element.files[0].name || null
      },

      showName () {
        this.showNameFiles = false
        setTimeout(() => {
          this.showNameFiles = true
        }, 10)
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../../scss/app";
.DocumentosObrigatorios {
  &--fileDisabled {
    background-color: #e9ecef;
    padding: 6px 15px;
    border-radius: 2px;
    font-size: 0.875rem;
    font-weight: 400;
    color: #495057;
    border: 1px solid #ced4da;
  }
}

.DropArea {
  height: 100px;
  padding: 5px;
  background-color: #f4f4f4;
  border:2px solid #086AAE;
  border-style: dashed;
}

.DropAreaDrag {
  height: 100px;
  padding: 5px;
  background-color: #3498db;
  color: #fff;
  border-color: #086AAE;
}

.fileObrigatorio {
  height: 95px;
  padding: 5px;
  width: 94%;
  margin-top: 4px;
  background-color: #f4f4f4;
  border-color: #086AAE;
  opacity: 0;
  z-index: 10;
  position: absolute;
  top: 0;
}
</style>
